import React from "react";
import { useIsAuthenticated, useMsalAuthentication } from "@azure/msal-react";
import { InteractionType } from "@azure/msal-browser";
import { loginRequest } from "./authentication/authConfig";

// eslint-disable-next-line react/prop-types
const Login = ({ children }) => {
  const isAuthenticated = useIsAuthenticated();

  // Initiate MSAL authentication flow
  useMsalAuthentication(InteractionType.Redirect, {
    scopes: loginRequest.scopes,
  });

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{isAuthenticated ? children : null}</>;
};

export default Login;
